module.exports = __webpack_public_path__ + "img/ibrahim-bodur.e61a1c02.jpg";